import 'simplebar/src/simplebar.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'src/static/yup/yupExtensions';

import { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';

import { MotionLazyContainer } from './components/animate';
import LoadingAPI from './components/LoadingAPI';
import { SettingsProvider } from './components/settings';
import SnackbarProvider from './components/snackbar/SnackbarProvider';
import i18n from './i18n/i18n';
import { LOCAL_STORAGE_KEY } from './static/constants';
import { RootStore, RootStoreProvider, setupRootStore } from './models';
import router from './routes';
import ThemeProvider from './theme';

export default function App() {
  const [rootStore, setRootStore] = useState<RootStore | undefined>(undefined);

  useEffect(() => {
    // mui pro license
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_LICENSE_KEY);

    // setup root store
    setupRootStore().then((store) => {
      setRootStore(store);
    });
    localStorage.removeItem(LOCAL_STORAGE_KEY.COPIED_CONTENTS);
  }, []);

  if (!rootStore) return null;

  const originalWarn = console.warn;

  console.warn = (...args) => {
    // TODO v7 router 경고
    if (typeof args[0] === 'string' && args[0].includes('React Router Future Flag Warning')) {
      return;
    }
    originalWarn(...args);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <RootStoreProvider value={rootStore}>
        <ThemeProvider>
          <SettingsProvider>
            <SnackbarProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MotionLazyContainer>
                  {/* <ThemeLocalization> */}
                  <HelmetProvider>
                    <RouterProvider router={router} />
                  </HelmetProvider>
                  <LoadingAPI />
                  {/* </ThemeLocalization> */}
                </MotionLazyContainer>
              </LocalizationProvider>
            </SnackbarProvider>
          </SettingsProvider>
        </ThemeProvider>
      </RootStoreProvider>
    </I18nextProvider>
  );
}
